import '@/styles/index.less';
import init from '../initSPA';
import Index from './Index.vue';
import { env, Runtime } from '@/common';
import { getConfigFromHorn } from '@/common/horn';
import { HornKey, PayOrigin } from '@/common/constant';

const routes = [
  {
    path: '/',
    component: Index,
    meta: {
      // 主页的titlebar为自绘
      title: ' '
    }
  }
];

async function initPage() {
  try {
    await env.initEnv();
    if (env.isNative && !env.isHarmony) {
      const config = await getConfigFromHorn(HornKey, {
        ab: [],
        redirect: {
          blackList: [],
          whiteList: [],
          tailNoList: [],
        },
      });
      const userId = Number(env.commonParams.userid) || 0;
      const tailNo = userId % 10;
      if (config.redirect) {
        const { whiteList, blackList, tailNoList } = config.redirect;
      // 黑名单直接进入支付设置页，根据userId尾数和白名单分流至支付管家
      if (
          blackList?.indexOf(userId) === -1 &&
          (whiteList?.indexOf(userId) !== -1 ||
            tailNoList.indexOf(tailNo) !== -1)
      ) {
          redirectPayManagement();
        }
      } else if (config.ab) {
        // 根据userId尾数分流至支付管家
        if (config.ab.indexOf(tailNo) !== -1) {
          redirectPayManagement();
        }
      }
    }
  } catch (e) {
    console.log(e);
  }

  init(routes);
}

function redirectPayManagement() {
  const origin =
    env.runtime > Runtime.Staging ? PayOrigin.test : PayOrigin.prod;
  location.href = `${origin}/resource/pay-management?utm_source=shezhiye`;
}

initPage();
